import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('image-click-areas', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('image-click-areas');

      return new ViewModel(params, element);
    },
  },
  template: html,
});
